export default __webpack_public_path__ + "static/gt-65052b5baef1fe9b1cb82497eb751f84.svg";